export enum ColorSchemeEnum {
  RED = 'red',
  BLUE = 'blue',
}
